import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { getOverviewTopicTimelineNew } from '@op/services';
import { useEffect, useState } from 'react';

export default function useOverviewTopicTimeline({
  filter,
  openUserCache,
}: {
  filter: any;
  openUserCache?: boolean;
}) {
  const [topic, setTopic] = useState<any>({});
  const { wrapperCancelRequest, loading } = useCancelRequestHook();

  function request() {
    wrapperCancelRequest(
      getOverviewTopicTimelineNew,
      filter,
      false,
      openUserCache ? { user_cache_expire: 5 } : {},
    ).then(data => {
      setTopic(data);
    });
  }

  useEffect(() => {
    if (filter?.edition_unified_id) {
      request();
    }
  }, [filter]);

  return { topic, loading };
}
